import { render, staticRenderFns } from "./ironSourceBackfillIcon.vue?vue&type=template&id=559b4f7b&"
import script from "./ironSourceBackfillIcon.vue?vue&type=script&lang=js&"
export * from "./ironSourceBackfillIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports